// TintiCloud — cliente HTTP para o Control Plane real.
// Autenticação via cookies httpOnly (nunca localStorage) — sempre credentials:"include".
// REACT_APP_BACKEND_URL="" (definida explicitamente, não ausente) = mesma origem —
// usado em produção quando o NPM roteia /api para o backend sob o mesmo domínio.
const BASE_URL = process.env.REACT_APP_BACKEND_URL !== undefined ? process.env.REACT_APP_BACKEND_URL : "http://localhost:8000";

export class ApiError extends Error {
  constructor(status, detail) {
    super(typeof detail === "string" ? detail : "request failed");
    this.status = status;
    this.detail = detail;
  }
}

let refreshing = null;

async function request(path, { method = "GET", body, retry = true } = {}) {
  const res = await fetch(`${BASE_URL}/api/v1${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401 && retry && !path.startsWith('/auth/')) {
    if (!refreshing) refreshing = request('/auth/refresh', {method:'POST', retry:false}).finally(() => {refreshing=null;});
    await refreshing;
    return request(path, {method, body, retry:false});
  }
  if (res.status === 204) return null;

  const isJson = res.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await res.json().catch(() => null) : null;

  if (!res.ok) {
    throw new ApiError(res.status, data?.detail || res.statusText);
  }
  return data;
}

export const http = {
  get: (path) => request(path),
  patch: (path, body) => request(path, {method:"PATCH", body}),
  delete: (path) => request(path, {method:"DELETE"}),
  post: (path, body) => request(path, { method: "POST", body: body ?? {} }),
};
